/**
 * Build the org-scoping filter used by campaign queries.
 *
 * Campaign data MUST be filtered by org ID, never by org name, because two
 * channel partners can each have a child org with the same name. Using the ID
 * guarantees only the selected org and its descendants are returned.
 */
export const buildOrgFilter = (orgIdOrIds) => {
  const ids = Array.isArray(orgIdOrIds) ? orgIdOrIds : [orgIdOrIds];
  if (ids.length === 1) {
    return {
      OR: [{ id: ids[0] }, { parentOrg_some: { id: ids[0] } }],
    };
  }
  return {
    OR: [{ id_in: ids }, { parentOrg_some: { id_in: ids } }],
  };
};
